// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__cVV_0","links":"styles_links__1zLCg","copyRight":"styles_copyRight__2h2JN"};